/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { action, makeObservable, observable } from 'mobx';

import type { GridProps } from '../../../interfaces';
import type { GridStore } from '../grid-store';

export class DisabledStateStore<RowDataT, TotalRowDataT, FilterT> {
    @observable disabled: boolean;

    constructor(
        private gridStore: GridStore<RowDataT, TotalRowDataT, FilterT>,
        props: GridProps<RowDataT, TotalRowDataT, FilterT>,
    ) {
        makeObservable(this);

        this.disabled = props.initialState?.disabled || false;
    }

    @action.bound
    enable(): void {
        this.disabled = false;
    }

    @action.bound
    disable(): void {
        this.disabled = true;
    }
}
